import React, { Component } from "react";
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import { translate } from "react-i18next"
import i18n from '../components/lang/i18n'
import {Link} from 'gatsby'
import FloatingWhatsApp from 'react-floating-whatsapp'
import 'react-floating-whatsapp/dist/index.css'

import avatar from '../assets/images/wa_avatar.jpg'
import banner from '../assets/images/banner3.jpg'
import faq1 from '../assets/images/faq1.jpg'
import faq2 from '../assets/images/faq2.jpg'
// import faq3 from '../assets/images/faq3.jpg'
import faq4 from '../assets/images/faq4.jpg'
import faq5 from '../assets/images/faq5.jpg'

const style = {
    backgroundImage: `url(${banner})`
};

class FAQ extends Component {
    constructor(props) {
      super(props);
      this.i18n = i18n;
      this.showMessage = this.showMessage.bind(this);
      this.handler = this.handler.bind(this)
      this.state = {
        message: "",
        isApp: false,
      };
    }

    handler() {
        this.setState({
          isApp: false,
        })
      }
  
    showMessage(message) {
      this.setState({
          message: message,
      });
    }
  
    render() {
      const { t } = this.props
      return (
        <Layout cl="" handler={this.handler}>
            <Helmet>
                <title>WFOW - {t("faq_title", "So Funktioniert's")}</title>
                <meta name="description" content="FAQ" />
            </Helmet>

            <section id="banner" className="" style={style}>
              <div className="inner">
                  <header className="major">
                      <h1>{t("faq_title", "So Funktioniert's")}</h1>
                  </header>
                  <div className="content">
                      <p>
                          {t("faq_subtitle", "Ein Profil zu erstellen ist einfach und kostenlos. Erzähl der Welt, wer du bist und was du machst. Dann weist WORLD FULL OF WOMEN Nutzer•innen weltweit den Weg zu dir.")}
                      </p>
                  </div>
              </div>
          </section>

          <div id="main" className="cards-top">
              <section id="one" className="cards-bg-white">
                <div className="inner">
                    <div className="grid-wrapper">
                        <div className="col-6">
                            
                            <header className="major">
                                <h2>{t("faq_title1", "Zusammen stark")}</h2>
                            </header>
                            <p>{t("faq_text1", "Beginne mit uns zusammen etwas komplett neues zu schaffen. Jede Plattform ist nur stark durch ihre User•innen. In unserem Fall sind es die mutigen Frauen, die den Schritt ins Unternehmertum gewagt haben. Wir stehen noch ganz am Anfang und wollen der Plattform WORLD FULL OF WOMEN nicht nur beim Wachsen zusehen, sondern sie auch gemeinsam mit den Userinnen weiterentwickeln und laufend verbessern. Komm an Board und werde Teil des Frauen-Netzwerkes!")}</p>
                    
                        </div>

                        <div className="col-2"></div>

                        <div className="col-4">
                            <img className="profilepic hila" src={faq1} alt="Zusammen stark" /><br/><br/>
                        </div>
                    </div>
                </div>
              </section>

              <section id="two" className="cards-top">
                <div className="inner">
                    <header className="major">
                        <h2>{t("faq_title2", "Unternehmerin im Fokus")}</h2>
                    </header>
                    <p>
                        {t("faq_text2", "Ob Cafe-Betreiberin, Ärztin oder Steuerberaterin – jede Frau, die selbstständig tätig ist, kann sich kostenlos registrieren. Und jede•r kann die App nutzen: WORLD FULL OF WOMEN weist den Weg zu Geschäften und Erlebnissen, die Frauen geschaffen haben.")}
                    </p>
                </div>
              </section>

              <section id="three" className="cards-top cards-bg-white">
                <div className="inner">
                    <div className="grid-wrapper">
                        <div className="col-4">
                            <img className="profilepic hila" src={faq2} alt="Die Registrierung" /><br/><br/>
                        </div>

                        <div className="col-2"></div>
                            
                        <div className="col-6">   
                            <header className="major">
                                <h2>{t("faq_title3", "Die Registrierung")}</h2>
                            </header>
                            <p>{t("faq_text3", "Wir benötigen ein paar Informationen von dir:")}</p>

                            <ul className="alt">
                                <li>{t("reg_infos_1", "1. Grundlegende Informationen")}</li>
                                <li>{t("reg_infos_2", "2. Infos zu deinem Unternehmen")}</li>
                                <li>{t("reg_infos_3", "3. Deine Beschreibung")}</li>
                                <li>{t("reg_infos_4", "4. Ein Foto von dir")}</li>
                                <li>{t("reg_infos_5", "5. Wo kann man dir folgen?")}</li>
                            </ul>

                            <ul className="actions">
                            <li>
                                <Link
                                aria-label="Link to Register Page"
                                to="/register"
                                className="button next"
                                >
                                {t("create_profile_button1", "Profil erstellen")}
                                </Link>
                            </li>
                            </ul>
                        </div>
                    </div>
                </div>
              </section>

              <section id="four" className="cards-top">
                <div className="inner">
                    <header className="major">
                        <h2>{t("faq_title4", "Nach der Registrierung")}</h2>
                    </header>

                    <h4 className="faq-questions">{t("faq_title4_subtitle1", "Social Media")}</h4>
                    <p>
                        {t("faq_text4_1", "Wir werden kostenlos über unsere Social Media Kanäle über dich erzählen (Basis für den Inhalt ist hier deine eigene Beschreibung) und dein Profil teilen. Zur Zeit ist unser Fokus auf Instagram, Facebook und LinkedIn. Die Welt freut sich auf deine Geschichte!")}
                    </p>

                    <h4 className="faq-questions">{t("faq_title4_subtitle2", "Events")}</h4>
                    <p>
                        {t("faq_text4_2", "Sobald WORLD FULL OF WOMEN groß genug für das erste Event ist, wirst du es als Erste erfahren. Wir freuen uns schon auf die Party, wenn wir die ersten 100 Unternehmerinnen haben – und sei es in einem Zoom Call.")}
                    </p>

                    <h4 className="faq-questions">{t("faq_title4_subtitle3", "Netzwerk")}</h4>
                    <p>
                        {t("faq_text4_3", "Wir lieben und wollen Austausch! Die Reise hat gerade erst begonnen und die ersten Ideen für eine Weiterentwicklung der Plattform sind auch schon da. Wir wollen ein zwangloses und effektives Netzwerken unter Frauen gestalten.")}
                    </p>
                </div>
              </section>

              <section id="five" className="cards-top cards-bg-white">
                <div className="inner">
                    <header className="major">
                        <h2>{t("faq_title5", "Unser Versprechen")}</h2>
                    </header>
                    <p>
                        {t("faq_text5", "Wir versprechen dir, mit deinen Daten sorgsam und sicher umzugehen. Wir sind jederzeit bereit, deine Fragen zu beantworten und offen für neue Ideen. Wir zeigen Gesicht und wollen mit dir zusammen etwas verändern. Wir wollen jeden Tag Spaß haben und die Plattform wachsen sehen. Wir wollen Gleichberechtigung und Chancengleichheit nicht nur zu predigen, sondern unterstützen.")}
                    </p>
                </div>
              </section>

              <section id="six" className="cards-top">
                <Link to="/contact" className="image alt-fit">
                    <img className="cards-bottom" src={faq4} alt="Hila + Annika" />
                    {/* <div className="parallax cards-bottom"></div> */}
                </Link>
                <div className="inner">
                    <header className="major">
                        <h2>{t("faq_title_6", "Häufige Fragen und Antworten")}</h2>
                    </header>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle1", "Kann ich mich bei WFOW registrieren?")}</h4>
                    <p>
                        {t("faq_text_6_1", "Du kannst dich bei WORLD FULL OF WOMEN registrieren, wenn du selbstständig (= nicht in einem abhängigen Arbeitsverhältnis) eine Tätigkeit ausführst, mit der du Gewinn erzielen möchtest.")}
                    </p>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle2", "Muss ich ein eingetragenes Unternehmen haben?")}</h4>
                    <p>
                        {t("faq_text_6_2", "Nein, du musst kein eingetragenes Unternehmen haben, um dich bei WORLD FULL OF WOMEN zu registrieren.")}
                    </p>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle3", "Muss mein Unternehmen eine bestimmte Größe / Anzahl von Mitarbeiter*innen haben?")}</h4>
                    <p>
                        {t("faq_text_6_3", "Nein, uns ist egal, wie groß oder klein dein Team und der Umfang deines Angebots ist.")}
                    </p>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle4", "Wie funktioniert die Anmeldung?")}</h4>
                    <p>
                        {t("faq_text_6_4", "Du registrierst dich auf unserer Website indem du das Formular auf der Registrierungs-Seite ausfüllst. Dabei gibst du deinen Vor- und Nachnamen sowie deine Mailadresse ein. Anschließend kannst du Informationen zu dir und deinem Unternehmen eingeben. Als Profilbild und Coverfoto akzeptieren wir Dateien im Format JPG, PNG und GIF. Das Motiv kannst du frei wählen, wir empfehlen aber ein Moodimage als Cover und dein Gesicht als Profilbild. Wenn du deine Registrierung abschickst, prüfen wir sie und schalten sie frei. Das war's. Sollte es zu Problemen bei deiner Registrierung kommen, kontaktiere uns einfach und wir helfen dir gerne weiter.")}
                    </p>
                    <ul className="actions">
                      <li>
                          <Link
                          aria-label="Link to Register Page"
                          to="/register"
                          className="button next"
                          >
                          {t("create_profile_button1", "Profil erstellen")}
                          </Link>
                      </li>
                    </ul>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle5", "Ist WFOW kostenlos?")}</h4>
                    <p>
                        {t("faq_text_6_5", "Ja, WORLD FULL OF WOMEN ist kostenlos – sowohl die Registrierung als Unternehmerin als auch die Nutzung der Website und App.")}
                    </p>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle6", "Sind meine Daten sicher?")}</h4>
                    <p>
                        {t("faq_text_6_6", "Die Sicherheit deiner Daten ist uns sehr wichtig. Die Erklärung, wie wir deine Daten schützen, findest du hier:")}
                    </p>

                    <ul className="actions">
                      <li>
                          <Link
                          aria-label="Link to Privacy Page"
                          to="/privacy"
                          className="button next"
                          >
                          {t("footer_privacy", "Datenschutzerklärung")}
                          </Link>
                      </li>
                    </ul>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle7", "Welchen Mehrwert hab ich als Unternehmerin, wenn ich mich mit meinem Business auf WFOW registriere?")}</h4>
                    <p>
                        {t("faq_text_6_7", "WORLD FULL OF WOMEN ist wie ein weiteres Ortsschild, dass deine Kund*innen zu dir führt. Wir werben für dich und es kostet dich nichts.")}
                    </p>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle8", "Warum gibt es WFOW? Brauchen wir das wirklich?")}</h4>
                    <p>
                        {t("faq_text_6_8", "WORLD FULL OF WOMEN gibt es, weil wir wollen, dass (1.) jede*r die Möglichkeit hat, gezielt nach Geschäften und Dienstleistungen von Frauen zu suchen und (2.) Frauen, die ein Unternehmen gegründet haben, sichtbarer werden. Wir finden, dass es das braucht, weil im Vergleich aktuell immer noch weniger Frauen gründen als Männer. Das finden wir auffällig, da genauso viele Frauen gute Ideen und Eigenschaften zur Unternehmensführung haben.")}
                    </p>

                    <hr/>

                    <h4 className="faq-questions">{t("faq_title_6_subtitle9", "Welche Ideologie steckt hinter WFOW? Seid ihr feministisch?")}</h4>
                    <p>
                        {t("faq_text_6_9", "Wir sind für die Gleichberechtigung, Selbstbestimmung und Freiheit aller Geschlechter, v. a. von Frauen, und gegen Sexismus. Wir setzen uns dafür ein, dass dies in unsere gesellschaftliche Norm wird. Also ja: Wir sind Feminist*innen.")}
                    </p>

                </div>
              </section>

              <section id="seven" className="cards-top cards-bg-white">
                <div className="inner">
                <div className="grid-wrapper">
                        <div className="col-6">
                            <header className="major">
                                <h2>{t("faq_title_7", "Frag Hila!")}</h2>
                            </header>
                            <p>
                                {t("faq_text_7", "Wir sind immer für dich da. Wir verstehen natürlich, wenn du noch Fragen hast und genau deshalb haben wir mehrere Möglichkeiten geschaffen, damit wir dir schnell helfen können. Hila freut sich auf all deine Fragen.")}
                            </p>
                            <ul className="actions">
                                <li>
                                    <Link
                                    aria-label="Link to Contact Page"
                                    to="/contact"
                                    className="button next"
                                    >
                                    {t("faq_contact", "Kontaktiere uns")}
                                    </Link>
                                </li>
                            </ul>
                        </div>

                        <div className="col-2"></div>

                        <div className="col-4">
                            <img className="profilepic hila" src={faq5} alt="Frag Hila" /><br/><br/>
                        </div>
                    </div>
                </div>
              </section>

                  
            {this.state.isApp ? null : (
                <>
                    <FloatingWhatsApp 
                        phoneNumber="491632221616"
                        statusMessage={t("whatsapp_status", "Antwortet in der Regel innerhalb von einem Tag")} 
                        chatMessage={t("whatsapp_message", "Wie kann ich dir helfen?")} 
                        accountName="Hila"
                        avatar={avatar}
                        darkMode={false}
                    />
                </>
            )}
            </div>
        </Layout>
      )
    }
} 
export default translate("Index")(FAQ)